function GetQueryString(name) { 
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"); 
    var r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
    var context = ""; 
    if (r != null) 
       context = r[2]; 
    reg = null; 
    r = null; 
    return context == null || context == "" || context == "undefined" ? "" : context; 
}

export function sessionSet(name, data) {
    if (data === '' || data === null) {
        sessionStorage.removeItem(name)
        return
    }
    if (typeof data === 'object') {
        sessionStorage.setItem(name, JSON.stringify(data))
    } else {
        sessionStorage.setItem(name, data)
    }
}

export function sessionGet(name) {
    const data = sessionStorage.getItem(name)
    try {
        return JSON.parse(data) || ""
    } catch (e) {
        return data || ""
    }
}

export function localSet(name, data) {
    if (data === '' || data === null) {
        localStorage.removeItem(name)
        return
    }
    if (typeof data === 'object') {
        localStorage.setItem(name, JSON.stringify(data))
    } else {
        localStorage.setItem(name, data)
    }
}

export function localGet(name) {
    const data = localStorage.getItem(name)
    try {
        return JSON.parse(data)
    } catch (e) {
        return data
    }
}